// Espelha EducationHierarchyService::IN_PROGRESS_STATUS da API e o
// src/utils/formation.js do front-manager. A base tem "Em andamento",
// "Em Andamento", "emandamento", "andamento", "cursando" e "em curso",
// gravados por caminhos diferentes (extração de CV, este app, modal do gestor,
// Gupy, Indeed, empregos.com.br). Comparar com igualdade exata, como esta tela
// fazia, deixava a formação vinda do CV fora do status e travava o candidato
// no campo de data de término. "Trancado" e "interrompido" ficam de fora de
// propósito: o curso parou, não está em curso.
const IN_PROGRESS = ["andamento", "cursando", "em curso"];

// Valor canônico gravado no banco. É o que o select desta tela oferece e o que
// o modal do gestor grava.
export const IN_PROGRESS_LABEL = "Em andamento";

const normalize = value =>
  String(value == null ? "" : value)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "");

/**
 * A formação está em curso agora?
 *
 * Depois que a extração de CV parou de gravar data de término em formação em
 * andamento, o `level` virou o único campo que carrega esse status: to_date
 * vazio passou a significar "não informado", não "está cursando".
 */
export const isFormationInProgress = level => {
  const normalizado = normalize(level);

  return IN_PROGRESS.some(status => normalizado.includes(normalize(status)));
};

/**
 * A data serve para exibir?
 *
 * A API manda "" e a string "null" além de null. E data zerada do MySQL sai
 * como "0000-00-00" ou, depois do accessor, como algo terminando em "-0001":
 * é resíduo, não data.
 */
export const isFormationDate = date => {
  if (date === null || date === undefined || date === "" || date === "null") {
    return false;
  }

  const texto = String(date);

  return texto.indexOf("0000-00-00") !== 0 && texto.indexOf("-0001") === -1;
};

/**
 * Texto do período de uma formação, para as telas de leitura.
 *
 * Curso em andamento não mostra término: quando existe data ali, é resíduo da
 * extração antiga ou previsão de conclusão, nunca término.
 */
export const formationPeriod = formation => {
  const temInicio = isFormationDate(formation && formation.from_date);
  const temFim = isFormationDate(formation && formation.to_date);

  if (isFormationInProgress(formation && formation.level)) {
    return temInicio ? `Início em ${formation.from_date}` : "Não informado";
  }

  if (temInicio && temFim) {
    return `${formation.from_date} até ${formation.to_date}`;
  }

  if (temInicio) {
    return `Início em ${formation.from_date}`;
  }

  if (temFim) {
    return `Até ${formation.to_date}`;
  }

  return "Não informado";
};
